module.exports = __webpack_public_path__ + "img-upsell-dark.8840091edaec1fe328acaf60fac25979.hashedasset.svg";